import { MESSAGES } from "@/constants";
import { SarasIQ } from "../icons";
import { AppError, RoleAccessError } from "@/types/error";
import { UserAvatar } from "../UserAvatar";
import { Card } from "../ui/card";
import { LINKS } from "@/constants";
interface FallbackProps {
    error?: AppError | RoleAccessError;
    showAvatar?: boolean;
    type?: "accessRestricted" | "serviceDown";
    downServices?: string[];
    /** Forwarded to UserAvatar's displayName override — see its doc comment. */
    displayName?: string;
    /** Forwarded to UserAvatar's displayEmail override — see its doc comment. */
    displayEmail?: string;
}
export default function RbacFallback({
  error,
  showAvatar,
  type = "accessRestricted",
  downServices = [],
  displayName,
  displayEmail,
}: FallbackProps) {
  const downServicesToDisplay = downServices.length
    ? downServices
    : [MESSAGES.SERVICE_STATUS.DEFAULT_SERVICE_NAME];

  const downServicesLabel =
    downServicesToDisplay.length === 1
      ? `${downServicesToDisplay[0]} ${MESSAGES.SERVICE_STATUS.DOWN_STATUS_SUFFIX}`
      : `${downServicesToDisplay.slice(0, -1).join(", ")} and ${downServicesToDisplay[downServicesToDisplay.length - 1]} ${MESSAGES.SERVICE_STATUS.DOWN_STATUS_SUFFIX_PLURAL}`;

  return (
    <div className="flex items-center relative justify-center h-screen w-full bg-background">
      <div className="w-[40%] text-center items-center flex flex-col gap-2">
      {
        type === "serviceDown" ? (
        <>
          <SarasIQ size={80} className="w-20 h-20 text-primary-500"/>
           <h1 className="text-2xl font-medium leading-8 text-foreground">
            {MESSAGES.SERVICE_STATUS.TITLE}
          </h1>
          <p className="text-sm leading-5 text-text-medium-emphasis max-w-[480px]">
            {MESSAGES.SERVICE_STATUS.DESCRIPTION}{" "}
            <a href={`mailto:${MESSAGES.SERVICE_STATUS.SUPPORT_EMAIL}`} className="text-primary-500 font-medium">
              {MESSAGES.SERVICE_STATUS.SUPPORT_EMAIL}
            </a>
          </p>
          <div className="mt-5 flex flex-col items-center gap-1">
            <p className="text-xs leading-4 text-text-light-emphasis">
              {MESSAGES.SERVICE_STATUS.REACH_OUT_NOTE}
            </p>
            <span className="inline-flex h-[18px] items-center rounded px-1 border-[0.5px] border-[var(--dash-hairline,var(--grey-300))] bg-[var(--dash-surface-2,var(--grey-50))] text-xs leading-4 text-[color:var(--dash-accent,var(--primary-500))]">
              {downServicesLabel}
            </span>
          </div>
        </>
        ) : error?.code === MESSAGES.ERROR_CODES.NETWORK || error?.code === MESSAGES.ERROR_CODES.SERVER_ERROR ?
        <>
          <SarasIQ size={80} className="w-20 h-20 text-primary-500"/>
          <div className="text-[18px] font-bold">
            {error?.title || 'Something went wrong'}
          </div>
          <div className="text-[14px]">
            {error?.description || 'Something went wrong. Please try again later.'}
          </div>
        </> :
        <>
          <img height="80" width="80" src="./gifs/restricted.gif" alt="" />
          <div className="text-[18px] font-bold">
              Access restricted!
          </div>
          <div className="text-[14px]">
              Looks like you don't have access to this module just yet. No worries—reach out to your admin to request access to this feature. If you're facing any issues, feel free to
              <a href={LINKS.TALK_TO_US} target="_blank" rel="noopener noreferrer" className="text-primary-500"> Contact Us</a>
          </div>
        </>
      }
      </div>
      {showAvatar && <div className="absolute bottom-2 left-2 w-[300px]">
        <Card className="align-left p-1">
        <UserAvatar displayName={displayName} displayEmail={displayEmail}/>
        </Card>
      </div>}
    </div>
  );
}